import { Component, ElementRef, Inject, ViewChild } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';

import { CommonModule } from '@angular/common';
import { Auth } from 'firebase/auth';
import {
  FirebaseStorage,
  getDownloadURL,
  ref,
  uploadBytes,
} from 'firebase/storage';
import { AUTH, STORAGE } from 'src/app/firebase-injection';
import { UserService } from 'src/app/services/user.service';

@Component({
  selector: 'app-profile-image-dialog',
  templateUrl: './profile-image-dialog.component.html',
  styleUrls: ['./profile-image-dialog.component.scss'],
  standalone: true,
  imports: [CommonModule, MatButtonModule, MatIconModule],
})
export class ProfileImageDialogComponent {
  @ViewChild('fileInput') fileInput!: ElementRef<HTMLInputElement>;

  selectedImage: string | null = null;
  animalImages = [
    'assets/avatars/cat.png',
    'assets/avatars/giraffe.png',
    'assets/avatars/elephant.png',
    'assets/avatars/dog.png',
    'assets/avatars/fawn.png',
    'assets/avatars/squirrel.png',
  ];
  constructor(
    @Inject(AUTH) private auth: Auth,
    private userService: UserService,
    @Inject(STORAGE) private storage: FirebaseStorage,
    public dialogRef: MatDialogRef<ProfileImageDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { current: string | null }
  ) {
    this.selectedImage = data?.current || null;
  }

  selectImage(img: string) {
    this.selectedImage = img;
  }

  removeImage() {
    this.selectedImage = null;

    this.dialogRef.close('');
  }

  triggerFileInput() {
    this.fileInput.nativeElement.click();
  }

  onFileSelected(event: Event) {
    const input = event.target as HTMLInputElement;
    if (!input.files || input.files.length === 0) return;

    const file = input.files[0];
    const reader = new FileReader();

    reader.onload = () => {
      this.selectedImage = reader.result as string;
    };

    reader.readAsDataURL(file);
  }

  async confirmSelection() {
    if (!this.selectedImage) return;

    const uid = this.auth.currentUser?.uid;
    if (!uid) return;

    if (this.selectedImage.startsWith('assets/')) {
      await this.userService.updateUserPartial(uid, {
        photoURL: this.selectedImage,
      });
      this.dialogRef.close(this.selectedImage);
      return;
    }

    const fileName = `avatars/${uid}_${Date.now()}.png`;
    const storageRef = ref(this.storage, fileName);
    const blob = this.dataURLtoBlob(this.selectedImage);

    await uploadBytes(storageRef, blob);
    const downloadURL = await getDownloadURL(storageRef);

    await this.userService.updateUserPartial(uid, {
      photoURL: downloadURL,
    });

    this.dialogRef.close(downloadURL);
  }

  dataURLtoBlob(dataUrl: string): Blob {
    const arr = dataUrl.split(',');
    const mime = arr[0].match(/:(.*?);/)![1];
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);

    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    return new Blob([u8arr], { type: mime });
  }
}
